import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-subscription',
  templateUrl: './all-subscription.component.html',
  styleUrls: ['./all-subscription.component.scss'],
})
export class AllSubscriptionComponent implements OnInit {

  loader:boolean = false;
  constructor() { }

  ngOnInit() {}

}
